export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-asl-5b7a7a2c93f86bdf9c8d97109d2b79c7.svg";